import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const StatusComingIcon = createIcon({
    viewBox: '0 0 17 22',
    path: (
        <Path
            d='M10.9996 4.5C12.0896 4.5 12.9996 3.58 12.9996 2.5C12.9996 1.96957 12.7889 1.46086 12.4139 1.08579C12.0388 0.710714 11.5301 0.5 10.9996 0.5C9.88965 0.5 8.99965 1.38 8.99965 2.5C8.99965 3.58 9.88965 4.5 10.9996 4.5ZM7.38965 18.38L8.38965 14L10.4996 16V22H12.4996V14.5L10.3896 12.5L10.9996 9.5C11.6844 10.2856 12.5297 10.9153 13.4785 11.3466C14.4272 11.7778 15.4575 12.0006 16.4996 12V10C14.5896 10 12.9996 9 12.1896 7.58L11.1896 6C10.7896 5.38 10.1896 5 9.49965 5C9.18965 5 8.99965 5.08 8.68965 5.08L3.49965 7.28V12H5.49965V8.58L7.28965 7.88L5.68965 16L0.789648 15L0.389648 17L7.38965 18.38Z'
            fill='currentColor'
        />
    ),
})

StatusComingIcon.displayName = 'StatusComingIcon'
